var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_vm._v(_vm._s(_vm.persona.nombre)+" "+_vm._s(_vm.persona.apellido)+": "+_vm._s(_vm.persona.stock_individual)+" unidades")])
}
var staticRenderFns = []

export { render, staticRenderFns }